module.exports = __webpack_public_path__ + "img/7@2x.b1c0f46c.png";